import { useEffect } from "react";

// Shows `title` (the session's detail.title) as the browser tab title while mounted.
// Empty `title` or unmount restores whatever index.html declared.
export default function useDocumentTitle(title) {
  const next = title == null ? "" : String(title).trim();
  useEffect(() => {
    if (!next || typeof document === "undefined") return undefined;
    const prev = document.title;
    document.title = next;
    return () => {
      document.title = prev;
    };
  }, [next]);
}
